/**
 * Class description
 *
 * Created: 2017-11-17
 * @author jonas
 */

import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TextureAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/TextureAsset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/BitmapFontAsset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/SpineAsset";

// To extend enum
// declare module "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName" {
//     export enum ResourcesGroupName {
//         GAME_GROUP = "gamegroup"
//     }
// }

// const temp = ResourcesGroupName as any;
// temp["GAME_GROUP"] = "gamegroup";

export class EdisonGameAssets {

    public static INTRO_BACKGROUND:string = "introBackground";

    public static MAIN_GAME_BACKGROUND:string = "";
    public static FREESPIN_BACKGROUND:string = "freespinBackground";

    public static REEL_FRAME_DARK:string = "reelFrameFS";
    public static REEL_FRAME_DARK_WP:string = "reelFrameFSWP";
    public static REEL_FRAME_WP:string = "reelFrameWP";
    public static REEL_FRAME:string = "reelFrame";


    public static getSymbolStateTexturePath(symbolName:string, stateName:string | null = null):string {
        if(stateName == null || stateName == "") {
            return symbolName + "/" + symbolName;
        }

        return symbolName + "/" + symbolName + "_" + stateName;
    }

    public static getSymbolStateTextures(symbolName:string, stateName:string | null = null):PIXI.Texture[] {
        return GameResources.getTextures(EdisonGameAssets.getSymbolStateTexturePath(symbolName, stateName));
    }

    public static RESOURCES_GROUPS:IResourcesGroupConfig = {
        intro : [
            {
                name : "fonts",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new BitmapFontAsset("numbersOpenSans800", "fonts/bitmapfonts/NumbersOpenSans800.fnt"),
                    new BitmapFontAsset("numbersWinCountUp", "fonts/bitmapfonts/NumbersWinCountUp.fnt"),
                    new BitmapFontAsset("winWaysNumbers", "fonts/bitmapfonts/WinWaysNumbers.fnt")
                ]
            },
            {
                name : "intro",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("intro0", "sheets/intro/intro0.json"),
                ],
                animations : {
                    "introLogo" : "introLogo",
                    "M1/M1" : "IntroFeatures/M1",
                    "M1/M1_Stack" : "IntroFeatures/M1_Stack",
                    "M1/M1_Stack_Gold" : "IntroFeatures/M1_Stack_Gold",
                    "M1/M1_gold" : "IntroFeatures/M1_gold",
                    "M2/M2" : "IntroFeatures/M2",
                    "M2/M2_Stack" : "IntroFeatures/M2_Stack",
                    "M2/M2_Stack_Gold" : "IntroFeatures/M2_Stack_Gold",
                    "M2/M2_gold" : "IntroFeatures/M2_gold",
                    "S/S" : "IntroFeatures/S",
                    "winWaysImage" : "winWaysSign/WinWays",
                    "waysWonImage" : "winWaysSign/WaysWon",
                    "wayWonImage" : "winWaysSign/WayWon",
                }
            },
            {
                name : "introBackground",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("introBackground0", "sheets/introBackground/introBackground0.json"),
                    new TextureAsset("introBackground1", "sheets/introBackground/introBackground1.json")
                ],
                animations : {}
            },
            {
                //Let's keep this sheet in 32-bit color
                name : "introBackgroundHighQuality",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("introBackgroundHighQuality0", "sheets/introBackgroundHighQuality/introBackgroundHighQuality0.json")
                ],
                animations : {
                }
            },
            {
                name : "spine",
                assets : [
                    new SpineAsset("backgroundSpine", "spine/Background.json"),
                    new SpineAsset("introFeatPres", "spine/IntroFeaturePresentation.json"),
                ]
            },
        ],

        main : [
            {
                //Let's keep this sheet in 32-bit color
                name : "mainHighQuality",
                assets : [
                    new TextureAsset("mainHighQuality0", "sheets/mainHighQuality/mainHighQuality0.json")
                ],
                animations : {
                }
            },
            {
                name : "main",
                assets : [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                    new TextureAsset("main2", "sheets/main/main2.json"),
                ],
                animations : {
                    "button" : "ui/gameTweakerButton/button",
                    "button-disabled" : "ui/gameTweakerButton/button-disabled",
                    "reelFrame" : "reelFrame/reelFrame",
                    "reelFrameDark" : "reelFrame/reelFrameDarkening",
                    "reelFrameFS" : "reelFrame/reelFrameFreespin",
                    "reelFrameFSWP" : "reelFrame/reelFrameFreespinDuringWin",
                    "reelFrameWP" : "reelFrame/reelFrameDuringWin",
                    "reelFrameBG" : "reelFrame/ReelBG",
                    "greenMeterNumber" : "meters/GreenMeterFreeSpinNumber",
                    "blueMeterNumber" : "meters/BlueMeterFreeSpinNumber",
                    "purpleMeterNumber" : "meters/PurpleMeterFreeSpinNumber",
                    "redMeterNumber" : "meters/RedMeterFreeSpinNumber",
                    "blackMeterNumber" : "meters/BlackMeterFreeSpinNumber",
                    "whiteMeterNumber" : "meters/WhiteMeterFreeSpinNumber",
                    "LandingAttentionFrameBlack" : "LandingAttentionFrame/LandingAttentionFrameBlack",
                    "LandingAttentionFrameBlue" : "LandingAttentionFrame/LandingAttentionFrameBlue",
                    "LandingAttentionFrameGreen" : "LandingAttentionFrame/LandingAttentionFrameGreen",
                    "LandingAttentionFramePurple" : "LandingAttentionFrame/LandingAttentionFramePurple",
                    "LandingAttentionFrameRed" : "LandingAttentionFrame/LandingAttentionFrameRed",
                    "LandingAttentionFrameYellow" : "LandingAttentionFrame/LandingAttentionFrameYellow",
                    "blueMeterNumberActive" : "meters/BlueMeterFreeSpinNumberActivated",
                    "purpleMeterNumberActive" : "meters/PurpleMeterFreeSpinNumberActivated",
                    "greenMeterNumberActive" : "meters/GreenMeterFreeSpinNumberActivated",
                    "redMeterNumberActive" : "meters/RedMeterFreeSpinNumberActivated",
                    "whiteMeterNumberActive" : "meters/WhiteMeterFreeSpinNumberActivated",
                    "blackMeterNumberActive" : "meters/BlackMeterFreeSpinNumberActivated",
                    "blueMeterNumberBgActive" : "meters/BlueMeterFreeSpinNumberDisplayActivated",
                    "purpleMeterNumberBgActive" : "meters/PurpleMeterFreeSpinNumberDisplayActivated",
                    "greenMeterNumberBgActive" : "meters/GreenMeterFreeSpinNumberDisplayActivated",
                    "redMeterNumberBgActive" : "meters/RedMeterFreeSpinNumberDisplayActivated",
                    "whiteMeterNumberBgActive" : "meters/WhiteMeterFreeSpinNumberDisplayActivated",
                    "blackMeterNumberBgActive" : "meters/BlackMeterFreeSpinNumberDisplayActivated",
                    "wpFrame" : "Initialwin_test/InitFrame",
                    "wpFrameStacked" : "Initialwin_test/InitFrameTall",
                    "respinBgRight" : "RespinBackgroundRight",
                    "respinBgLeft" : "RespinBackgroundLeft",
                    "logoText" : "LogoText",
                    "logoTop" : "LogoToppart",
                }
            },
            {
                name : "spine",
                assets : [
                    new SpineAsset("randomFeatureSpine", "spine/RandomFeature.json"),
                    new SpineAsset("meters", "spine/meters.json"),
                    new SpineAsset("shineSpine", "spine/Shine.json"),
                    new SpineAsset("blinkSpine", "spine/SymbolBlink.json"),
                    new SpineAsset("individualWinFrame", "spine/InitialWin.json"),
                    new SpineAsset("scatterAnticipation", "spine/SAnticipation.json"),
                    new SpineAsset("scatter", "spine/S.json"),
                    new SpineAsset("bugsyStacked", "spine/M1StackTrans.json"),
                    new SpineAsset("bettyStacked", "spine/M2StackTrans.json"),
                    new SpineAsset("bugsyStackedWild", "spine/M1StackTrans2wild.json"),
                    new SpineAsset("bettyStackedWild", "spine/M2StackTrans2wild.json"),
                    new SpineAsset("bugsyGold", "spine/GWPresBug.json"),
                    new SpineAsset("bettyGold", "spine/GWPresBet.json"),
                    new SpineAsset("wildParty", "spine/WildParty.json"),
                    new SpineAsset("bigWin", "spine/BigWin.json"),
                    new SpineAsset("goldBlink", "spine/SymbolBlink.json"),
                ]
            },
            {
                name : "mainJpeg",
                assets : [
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json"),
                    new TextureAsset("mainJpeg4", "sheets/mainJpeg/mainJpeg4.json"),
                    new TextureAsset("mainJpeg5", "sheets/mainJpeg/mainJpeg5.json"),
                    new TextureAsset("mainJpeg6", "sheets/mainJpeg/mainJpeg6.json"),
                ],
                animations : {
                    "individualWPAnim" : "FireWinPresentation/WinPres",
                    "fsIntroBg" : "freespin/freespinIntro",
                    "fsOutroBg" : "freespin/freespinOutro",
                }
            },
            {
                //Let's keep this sheet in 32-bit color
                name : "symbols",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json")
                ]
            },
            {
                name : "swoosh",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("swoosh0", "sheets/swoosh/swoosh0.json")
                ],
                animations : {}
            }
        ]
    };
}